<template>
  <div id="footer" class="container-fluid">
    <ul>
      <li>{{ $t('About Us') }}</li>
      <li>{{ $t('Contact') }}</li>
      <li>{{ $t('Cooperation') }}</li>
      <li>{{ $t('Help') }}</li>
      <li>{{ $t('Links') }}</li>
    </ul>
    <div class="footer-bottom">
      <p>
        {{ $t('Website Version') }}
        www.zhixuejun.com，All Rights Reserved.
      </p>
      <p>
        TOEFL® is a registered trademark of Educational Testing Service (ETS).
        This website is not endorsed or approved by ETS.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
#footer {
  min-width: 1202px;
  /*height:30px;*/
  color: #fff;
  /*background: #474747;*/
  overflow: hidden;
  text-align: center;
  /* line-height: 50px;*/
  height: 139px;
  margin-top: 65px;
}
#footer ul {
  width: 500px;
  margin: 12px auto;
  overflow: hidden;
  font-size: 16px;
  color: #637a91;
  text-align: center;
  height: 16px;
  line-height: 16px;
}
#footer li {
  width: 100px;
  box-sizing: border-box;
  float: left;
  padding: 0 10px;
}

.footer-bottom {
  overflow: hidden;
  width: 100%;
  height: 79px;
  padding: 20px 0;
  background: #637a91;
}
.footer-bottom p {
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  line-height: 39px;
}
</style>




// WEBPACK FOOTER //
// src/components/common/Footer.vue